import { StudentPerformanceList } from './StudentPerformanceList';

export default {
    list: StudentPerformanceList,
};
